(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awk-alltagshelfer-product-legacy-140826"] && !Shopify.designMode) return;
  try {
    
(() => {
    const initializeBundleForms = (root = document) => {
      root.querySelectorAll('[data-awk-bundle-form]').forEach((form) => {
        if (form.dataset.awkBundleReady === 'true') return;
        form.dataset.awkBundleReady = 'true';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          const currentVariant = form.querySelector('input[name="items[0][id]"]');
          const selectedVariant = form.querySelector('input[name="items[1][id]"]:checked');
          const submitButton = form.querySelector('[data-awk-bundle-submit]');
          const errorMessage = form.querySelector('[data-awk-bundle-error]');

          if (!currentVariant || !selectedVariant || !submitButton) return;

          const originalButtonContent = submitButton.innerHTML;
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.querySelector('span').textContent = 'Wird hinzugefügt …';
          if (errorMessage) {
            errorMessage.hidden = true;
            errorMessage.textContent = '';
          }

          let deferredCartUpdate;

          try {
            const cartSectionIds = [
              ...new Set(
                Array.from(document.querySelectorAll('cart-items-component'))
                  .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
                  .filter(Boolean)
              )
            ];
            const items = [
              { id: Number(currentVariant.value), quantity: 1 },
              { id: Number(selectedVariant.value), quantity: 1 }
            ];
            const { CartLinesUpdateEvent } = await import('@shopify/events');
            deferredCartUpdate = CartLinesUpdateEvent.createPromise();

            form.dispatchEvent(new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({
                merchandiseId: String(item.id),
                quantity: item.quantity
              })),
              promise: deferredCartUpdate.promise
            }));

            const response = await fetch(form.dataset.cartAddUrl || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items,
                sections: cartSectionIds.join(',')
              })
            });

            const payload = await response.json().catch(() => ({}));
            if (!response.ok) {
              throw new Error(payload.description || payload.message || 'Die Auswahl konnte nicht hinzugefügt werden.');
            }

            const cartResponse = await fetch(`${form.dataset.cartUrl || '/cart'}.js`, {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin'
            });
            if (!cartResponse.ok) {
              throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
            }

            const ajaxCart = await cartResponse.json();
            deferredCartUpdate.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: {
                items: ajaxCart.items,
                source: 'awk-bundle',
                sourceId: form.id,
                itemCount: items.length,
                productId: form.dataset.productId,
                sections: payload.sections,
                didError: false
              }
            });

            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.innerHTML = originalButtonContent;
          } catch (error) {
            deferredCartUpdate?.reject(error);
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.innerHTML = originalButtonContent;
            if (errorMessage) {
              errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
              errorMessage.hidden = false;
            }
          }
        });
      });
    };

    const initializeStickyBuy = (root = document) => {
      root.querySelectorAll('.awk-ap:not(.awk-ap--standard) [data-awk-sticky-buy]').forEach((bar) => {
        if (bar.dataset.awkStickyReady === 'true') return;
        bar.dataset.awkStickyReady = 'true';

        const article = bar.closest('.awk-ap');
        if (!article) return;
        const scrollContainer = article.closest('.page-wrapper');
        const footerBoundary = scrollContainer?.querySelector('footer, .shopify-section-group-footer-group')
          || document.querySelector('footer, .shopify-section-group-footer-group');
        const mobileViewport = window.matchMedia('(max-width: 990px), (hover: none) and (pointer: coarse)');

        const portalBarToViewport = () => {
          if (!mobileViewport.matches || bar.parentElement === document.body) return;

          const articleStyles = window.getComputedStyle(article);
          const customProperties = ['--ap-gold-soft', '--ap-gold', '--ap-black', '--ap-white', '--ap-cream']
            .map((property) => [property, articleStyles.getPropertyValue(property)]);

          customProperties.forEach(([property, value]) => {
            if (value) bar.style.setProperty(property, value);
          });
          document.body.appendChild(bar);
          bar.dataset.awkMobilePortal = 'true';
        };

        const readScrollProgress = () => {
          const viewportHeight = window.visualViewport?.height
            || window.innerHeight
            || document.documentElement.clientHeight;
          const windowTop = Math.max(
            window.scrollY || 0,
            document.documentElement.scrollTop || 0,
            document.body.scrollTop || 0
          );
          const windowHeight = Math.max(
            document.documentElement.scrollHeight || 0,
            document.body.scrollHeight || 0
          );
          const windowMax = Math.max(windowHeight - viewportHeight, 0);
          const wrapperTop = scrollContainer?.scrollTop || 0;
          const wrapperMax = scrollContainer
            ? Math.max(scrollContainer.scrollHeight - scrollContainer.clientHeight, 0)
            : 0;
          const windowRatio = windowMax > 0 ? Math.min(Math.max(windowTop / windowMax, 0), 1) : 0;
          const wrapperRatio = wrapperMax > 0 ? Math.min(Math.max(wrapperTop / wrapperMax, 0), 1) : 0;

          return {
            ratio: Math.max(windowRatio, wrapperRatio),
            viewportHeight,
            source: wrapperRatio > windowRatio ? 'wrapper' : 'window'
          };
        };

        let frameRequested = false;
        const update = () => {
          frameRequested = false;
          const metrics = readScrollProgress();
          const previewBarHeight = document.getElementById('PBarNextFrameWrapper')?.getBoundingClientRect().height || 0;
          const footerTop = footerBoundary?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
          const footerLimit = Math.max(metrics.viewportHeight - previewBarHeight, 0);
          const shouldShow = metrics.ratio >= 0.5 && footerTop > footerLimit;
          const visibilityChanged = bar.classList.contains('is-visible') !== shouldShow;
          const bottomValue = `max(${previewBarHeight + 18}px, env(safe-area-inset-bottom))`;

          bar.dataset.awkScrollRatio = metrics.ratio.toFixed(3);
          bar.dataset.awkScrollSource = metrics.source;
          if (bar.dataset.awkStickyBottom !== bottomValue) {
            bar.dataset.awkStickyBottom = bottomValue;
            bar.style.setProperty('bottom', bottomValue, 'important');
          }
          bar.classList.toggle('is-visible', shouldShow);
          bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          if (visibilityChanged) {
            window.dispatchEvent(new CustomEvent('awk:sticky-buy-change', {
              detail: { visible: shouldShow }
            }));
          }

          if (shouldShow) {
            bar.removeAttribute('inert');
          } else {
            bar.setAttribute('inert', '');
          }
        };

        const requestUpdate = () => {
          if (frameRequested) return;
          frameRequested = true;
          window.requestAnimationFrame(update);
        };

        const handleViewportChange = () => {
          portalBarToViewport();
          requestUpdate();
        };

        portalBarToViewport();
        mobileViewport.addEventListener('change', handleViewportChange);
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate, { passive: true });
        window.addEventListener('orientationchange', requestUpdate, { passive: true });
        scrollContainer?.addEventListener('scroll', requestUpdate, { passive: true });
        window.visualViewport?.addEventListener('scroll', requestUpdate, { passive: true });
        window.visualViewport?.addEventListener('resize', requestUpdate, { passive: true });
        requestUpdate();
        window.setTimeout(requestUpdate, 1200);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeBundleForms();
        initializeStickyBuy();
      });
    } else {
      initializeBundleForms();
      initializeStickyBuy();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeBundleForms(event.target);
      initializeStickyBuy(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awk-alltagshelfer-product"] && !Shopify.designMode) return;
  try {
    
(() => {
    const initializeBundleForms = (root = document) => {
      root.querySelectorAll('[data-awk-bundle-form]').forEach((form) => {
        if (form.dataset.awkBundleReady === 'true') return;
        form.dataset.awkBundleReady = 'true';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          const currentVariant = form.querySelector('input[name="items[0][id]"]');
          const selectedVariant = form.querySelector('input[name="items[1][id]"]:checked');
          const submitButton = form.querySelector('[data-awk-bundle-submit]');
          const errorMessage = form.querySelector('[data-awk-bundle-error]');

          if (!currentVariant || !selectedVariant || !submitButton) return;

          const originalButtonContent = submitButton.innerHTML;
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.querySelector('span').textContent = 'Wird hinzugefügt …';
          if (errorMessage) {
            errorMessage.hidden = true;
            errorMessage.textContent = '';
          }

          let deferredCartUpdate;

          try {
            const cartSectionIds = [
              ...new Set(
                Array.from(document.querySelectorAll('cart-items-component'))
                  .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
                  .filter(Boolean)
              )
            ];
            const items = [
              { id: Number(currentVariant.value), quantity: 1 },
              { id: Number(selectedVariant.value), quantity: 1 }
            ];
            const { CartLinesUpdateEvent } = await import('@shopify/events');
            deferredCartUpdate = CartLinesUpdateEvent.createPromise();

            form.dispatchEvent(new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: items.map((item) => ({
                merchandiseId: String(item.id),
                quantity: item.quantity
              })),
              promise: deferredCartUpdate.promise
            }));

            const response = await fetch(form.dataset.cartAddUrl || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items,
                sections: cartSectionIds.join(',')
              })
            });

            const payload = await response.json().catch(() => ({}));
            if (!response.ok) {
              throw new Error(payload.description || payload.message || 'Die Auswahl konnte nicht hinzugefügt werden.');
            }

            const cartResponse = await fetch(`${form.dataset.cartUrl || '/cart'}.js`, {
              headers: { 'Accept': 'application/json' },
              credentials: 'same-origin'
            });
            if (!cartResponse.ok) {
              throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
            }

            const ajaxCart = await cartResponse.json();
            deferredCartUpdate.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: {
                items: ajaxCart.items,
                source: 'awk-bundle',
                sourceId: form.id,
                itemCount: items.length,
                productId: form.dataset.productId,
                sections: payload.sections,
                didError: false
              }
            });

            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.innerHTML = originalButtonContent;
          } catch (error) {
            deferredCartUpdate?.reject(error);
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.innerHTML = originalButtonContent;
            if (errorMessage) {
              errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
              errorMessage.hidden = false;
            }
          }
        });
      });
    };

    const initializeStickyBuy = (root = document) => {
      root.querySelectorAll('.awk-ap:not(.awk-ap--standard) [data-awk-sticky-buy]').forEach((bar) => {
        if (bar.dataset.awkStickyReady === 'true') return;
        bar.dataset.awkStickyReady = 'true';

        const article = bar.closest('.awk-ap');
        if (!article) return;
        const scrollContainer = article.closest('.page-wrapper');
        const footerBoundary = scrollContainer?.querySelector('footer, .shopify-section-group-footer-group')
          || document.querySelector('footer, .shopify-section-group-footer-group');
        const mobileViewport = window.matchMedia('(max-width: 990px), (hover: none) and (pointer: coarse)');

        const portalBarToViewport = () => {
          if (!mobileViewport.matches || bar.parentElement === document.body) return;

          const articleStyles = window.getComputedStyle(article);
          const customProperties = ['--ap-gold-soft', '--ap-gold', '--ap-black', '--ap-white', '--ap-cream']
            .map((property) => [property, articleStyles.getPropertyValue(property)]);

          customProperties.forEach(([property, value]) => {
            if (value) bar.style.setProperty(property, value);
          });
          document.body.appendChild(bar);
          bar.dataset.awkMobilePortal = 'true';
        };

        const readScrollProgress = () => {
          const viewportHeight = window.visualViewport?.height
            || window.innerHeight
            || document.documentElement.clientHeight;
          const windowTop = Math.max(
            window.scrollY || 0,
            document.documentElement.scrollTop || 0,
            document.body.scrollTop || 0
          );
          const windowHeight = Math.max(
            document.documentElement.scrollHeight || 0,
            document.body.scrollHeight || 0
          );
          const windowMax = Math.max(windowHeight - viewportHeight, 0);
          const wrapperTop = scrollContainer?.scrollTop || 0;
          const wrapperMax = scrollContainer
            ? Math.max(scrollContainer.scrollHeight - scrollContainer.clientHeight, 0)
            : 0;
          const windowRatio = windowMax > 0 ? Math.min(Math.max(windowTop / windowMax, 0), 1) : 0;
          const wrapperRatio = wrapperMax > 0 ? Math.min(Math.max(wrapperTop / wrapperMax, 0), 1) : 0;

          return {
            ratio: Math.max(windowRatio, wrapperRatio),
            viewportHeight,
            source: wrapperRatio > windowRatio ? 'wrapper' : 'window'
          };
        };

        let frameRequested = false;
        const update = () => {
          frameRequested = false;
          const metrics = readScrollProgress();
          const previewBarHeight = document.getElementById('PBarNextFrameWrapper')?.getBoundingClientRect().height || 0;
          const footerTop = footerBoundary?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
          const footerLimit = Math.max(metrics.viewportHeight - previewBarHeight, 0);
          const shouldShow = metrics.ratio >= 0.5 && footerTop > footerLimit;
          const visibilityChanged = bar.classList.contains('is-visible') !== shouldShow;
          const bottomValue = `max(${previewBarHeight + 18}px, env(safe-area-inset-bottom))`;

          bar.dataset.awkScrollRatio = metrics.ratio.toFixed(3);
          bar.dataset.awkScrollSource = metrics.source;
          if (bar.dataset.awkStickyBottom !== bottomValue) {
            bar.dataset.awkStickyBottom = bottomValue;
            bar.style.setProperty('bottom', bottomValue, 'important');
          }
          bar.classList.toggle('is-visible', shouldShow);
          bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          if (visibilityChanged) {
            window.dispatchEvent(new CustomEvent('awk:sticky-buy-change', {
              detail: { visible: shouldShow }
            }));
          }

          if (shouldShow) {
            bar.removeAttribute('inert');
          } else {
            bar.setAttribute('inert', '');
          }
        };

        const requestUpdate = () => {
          if (frameRequested) return;
          frameRequested = true;
          window.requestAnimationFrame(update);
        };

        const handleViewportChange = () => {
          portalBarToViewport();
          requestUpdate();
        };

        portalBarToViewport();
        mobileViewport.addEventListener('change', handleViewportChange);
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate, { passive: true });
        window.addEventListener('orientationchange', requestUpdate, { passive: true });
        scrollContainer?.addEventListener('scroll', requestUpdate, { passive: true });
        window.visualViewport?.addEventListener('scroll', requestUpdate, { passive: true });
        window.visualViewport?.addEventListener('resize', requestUpdate, { passive: true });
        requestUpdate();
        window.setTimeout(requestUpdate, 1200);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeBundleForms();
        initializeStickyBuy();
      });
    } else {
      initializeBundleForms();
      initializeStickyBuy();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeBundleForms(event.target);
      initializeStickyBuy(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awk-motion-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('awk-deferred-shop-follow')) {
    customElements.define('awk-deferred-shop-follow', class extends HTMLElement {
      connectedCallback() {
        if (this.mounted || this.observer) return;
        if (!('IntersectionObserver' in window)) {
          this.mount();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.mount();
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }

      mount() {
        if (this.mounted) return;
        const template = this.querySelector('template');
        if (!template) return;
        this.mounted = true;
        const fragment = template.content.cloneNode(true);
        const scripts = [...fragment.querySelectorAll('script')];
        scripts.forEach((script) => script.remove());
        this.append(fragment);
        scripts.forEach((original) => {
          const script = document.createElement('script');
          for (const attribute of original.attributes) {
            script.setAttribute(attribute.name, attribute.value);
          }
          script.textContent = original.textContent;
          this.append(script);
        });
        template.remove();
        this.dataset.loaded = 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awk-standard-product"] && !Shopify.designMode) return;
  try {
    
(() => {
    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-AT', {
          style: 'currency',
          currency: currency || 'EUR'
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
      }
    };

	    const setButtonState = (button, available) => {
	      if (!button) return;
	      button.disabled = !available;
	      const article = button.closest('[data-awk-standard-buybox]');
	      const label = button.querySelector('.add-to-cart-text__content span span');
	      const availableLabel = button.classList.contains('awk-ap__sticky-buy-button')
	        ? article?.dataset.stickyAddLabel || 'Warenkorb'
	        : article?.dataset.addLabel || 'In den Warenkorb';
	      if (label) label.textContent = available ? availableLabel : article?.dataset.unavailableLabel || 'Aktuell nicht verfügbar';
    };

    const initializeStandardProduct = (root = document) => {
      root.querySelectorAll('[data-awk-standard-buybox]').forEach((article) => {
        if (article.dataset.awkStandardReady === 'true') return;
        article.dataset.awkStandardReady = 'true';

        let variants = [];
        try {
          variants = JSON.parse(article.querySelector('[data-awk-standard-variants]')?.textContent || '[]');
        } catch (error) {
          variants = [];
        }
        if (!variants.length) return;

        let unitPrices = {};
        try {
          unitPrices = JSON.parse(article.querySelector('[data-awk-standard-unit-prices]')?.textContent || '{}');
        } catch (error) {
          unitPrices = {};
        }

        const currency = article.dataset.currency || 'EUR';
        const currentPrice = article.querySelector('[data-awk-price-current]');
        const comparePrice = article.querySelector('[data-awk-price-compare]');
        const saving = article.querySelector('[data-awk-price-save]');
        const sale20Price = article.querySelector('[data-awk-sale20-price]');
        const extra30Price = article.querySelector('[data-awk-extra30-price]');
        const unitPrice = article.querySelector('[data-awk-unit-price]');
        const discount = article.querySelector('[data-awk-discount]');
        const stock = article.querySelector('[data-awk-stock]');
        const stockText = stock?.querySelector('span');
        const stickyPrice = article.querySelector('[data-awk-sticky-price]');
        const stickyCompare = article.querySelector('[data-awk-sticky-compare]');
        const stickyButton = article.querySelector('.awk-ap__sticky-buy-button');
        const variantInputs = [...article.querySelectorAll('[data-awk-variant-input]')];
        const gallery = article.querySelector('[data-awk-standard-gallery]');
        const galleryMedia = gallery ? [...gallery.querySelectorAll('.awk-ap__media')] : [];
        const galleryThumbs = [...article.querySelectorAll('[data-awk-gallery-index]')];
        const galleryCounter = article.querySelector('[data-awk-gallery-current]');
        const mobileGallery = window.matchMedia('(max-width: 749px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let activeGalleryIndex = 0;
        const markGalleryImage = (index) => {
          activeGalleryIndex = index;
          galleryMedia.forEach((media, mediaIndex) => media.classList.toggle('is-active', mediaIndex === index));
          galleryThumbs.forEach((button, buttonIndex) => {
            button.setAttribute('aria-current', String(buttonIndex === index));
          });
          if (galleryCounter) galleryCounter.textContent = String(index + 1);
        };
        const scrollGalleryImage = (index) => {
          const media = galleryMedia[index];
          if (!gallery || !media) return;
          markGalleryImage(index);
          if (!mobileGallery.matches) return;
          const left = media.getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft;
          gallery.scrollTo({ left, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        };
        mobileGallery.addEventListener('change', () => scrollGalleryImage(activeGalleryIndex));
        galleryThumbs.forEach((button) => {
          button.addEventListener('click', () => scrollGalleryImage(Number(button.dataset.awkGalleryIndex)));
        });
        let galleryFrame = 0;
        gallery?.addEventListener('scroll', () => {
          if (!mobileGallery.matches || galleryFrame) return;
          galleryFrame = requestAnimationFrame(() => {
            galleryFrame = 0;
            const width = gallery.clientWidth;
            if (width > 0) markGalleryImage(Math.min(galleryMedia.length - 1, Math.max(0, Math.round(gallery.scrollLeft / width))));
          });
        }, { passive: true });

        const updateVariant = (variantId) => {
          const variant = variants.find((item) => String(item.id) === String(variantId));
          if (!variant) return;

          variantInputs.forEach((input) => {
            const variantValue = String(variant.id);
            input.value = variantValue;
            input.setAttribute('value', variantValue);
            input.dispatchEvent(new Event('change', { bubbles: true }));
            if (input.value !== variantValue) input.value = variantValue;
          });

          const shippingLabel = article.querySelector('[data-awk-product-shipping]');
          if (shippingLabel) {
            const freeShipping = article.dataset.awkFreeShippingItem === 'true' || variant.price >= 7500;
            const localShipping = ['AT', 'DE'].includes(article.dataset.awkShippingCountry);
            shippingLabel.textContent = freeShipping ? 'Gratis Versand' : localShipping ? '6,90 € Versand · gratis ab 75 €' : 'Versandkosten im Checkout';
          }
          if (currentPrice) currentPrice.textContent = formatMoney(variant.price, currency);
          if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, currency);
          if (sale20Price) sale20Price.textContent = formatMoney(Math.round(Number(variant.price || 0) * 0.8), currency);
          if (extra30Price) extra30Price.textContent = formatMoney(Math.round(Number(variant.price || 0) * 0.7), currency);

          if (unitPrice) {
            const unitPriceMarkup = unitPrices[String(variant.id)] || '';
            unitPrice.hidden = !unitPriceMarkup;
            unitPrice.innerHTML = unitPriceMarkup;
          }

          const hasComparePrice = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
          const difference = hasComparePrice ? Number(variant.compare_at_price) - Number(variant.price) : 0;
          const discountPercent = hasComparePrice ? Math.round(difference * 100 / Number(variant.compare_at_price)) : 0;

          if (comparePrice) {
            comparePrice.hidden = !hasComparePrice;
            comparePrice.textContent = hasComparePrice ? formatMoney(variant.compare_at_price, currency) : '';
          }
          if (saving) {
            saving.hidden = !hasComparePrice;
	            const savingTemplate = article.dataset.savingTemplate || 'Sie sparen [betrag]';
	            saving.textContent = hasComparePrice ? savingTemplate.replace('[betrag]', formatMoney(difference, currency)) : '';
          }
          if (stickyCompare) {
            stickyCompare.hidden = !hasComparePrice;
            stickyCompare.textContent = hasComparePrice ? formatMoney(variant.compare_at_price, currency) : '';
          }
          if (discount) {
            discount.hidden = !hasComparePrice;
            const discountTemplate = discount.dataset.awkDiscountTemplate || '-__PERCENT__%';
            discount.textContent = hasComparePrice ? discountTemplate.replace('__PERCENT__', discountPercent) : '';
          }

	          if (stock && stockText) {
	            stock.classList.toggle('is-sold-out', !variant.available);
	            if (!variant.available) {
	              stockText.textContent = article.dataset.unavailableLabel || 'Aktuell nicht verfügbar';
	            } else if (variant.inventory_management && Number(variant.inventory_quantity) > 0 && Number(variant.inventory_quantity) <= 5) {
	              const lowStockTemplate = article.dataset.lowStockTemplate || 'Nur [anzahl] Stück übrig – fast ausverkauft!';
	              stockText.textContent = lowStockTemplate.replace('[anzahl]', variant.inventory_quantity);
	            } else {
	              stockText.textContent = article.dataset.inStockLabel || 'Auf Lager und versandbereit';
	            }
          }

          article.querySelectorAll('.awk-ap__atc').forEach((button) => {
            setButtonState(button, Boolean(variant.available));
          });
          setButtonState(stickyButton, Boolean(variant.available));

          const mediaId = variant.featured_image?.id || variant.featured_media?.id;
          if (mediaId && gallery) {
            const media = gallery.querySelector('[data-media-id="' + mediaId + '"]');
            if (media) {
              gallery.querySelectorAll('.awk-ap__media').forEach((item) => item.classList.remove('is-selected'));
              media.classList.add('is-selected');
              scrollGalleryImage(galleryMedia.indexOf(media));
            }
          }

          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          } catch (error) {
            /* The selected variant still remains functional without URL synchronization. */
          }
        };

        article.querySelectorAll('[data-awk-variant-picker] input[type="radio"]').forEach((input) => {
          input.addEventListener('change', () => {
            if (input.checked) updateVariant(input.value);
          });
        });
        article.querySelector('[data-awk-variant-select]')?.addEventListener('change', (event) => {
          updateVariant(event.currentTarget.value);
        });

        const initialVariantId = article.querySelector('[data-awk-variant-picker] input[type="radio"]:checked')?.value
          || article.querySelector('[data-awk-variant-select]')?.value
          || variants[0]?.id;

        if (initialVariantId) {
          variantInputs.forEach((input) => {
            const variantValue = String(initialVariantId);
            input.value = variantValue;
            input.setAttribute('value', variantValue);
          });
        }
      });
    };

    const initializeStickyBuy = (root = document) => {
      root.querySelectorAll('[data-awk-standard-buybox] [data-awk-sticky-buy]').forEach((bar) => {
        if (bar.dataset.awkStickyReady === 'true') return;
        bar.dataset.awkStickyReady = 'true';

        const article = bar.closest('[data-awk-standard-buybox]');
        if (!article) return;
        const scrollContainer = article.closest('.page-wrapper');
        const footerBoundary = scrollContainer?.querySelector('footer, .shopify-section-group-footer-group')
          || document.querySelector('footer, .shopify-section-group-footer-group');
        const mobileViewport = window.matchMedia('(max-width: 990px), (hover: none) and (pointer: coarse)');

        const portalBarToViewport = () => {
          if (!mobileViewport.matches || bar.parentElement === document.body) return;

          const articleStyles = window.getComputedStyle(article);
          const customProperties = ['--ap-gold-soft', '--ap-gold', '--ap-black', '--ap-white', '--ap-cream']
            .map((property) => [property, articleStyles.getPropertyValue(property)]);

          customProperties.forEach(([property, value]) => {
            if (value) bar.style.setProperty(property, value);
          });
          document.body.appendChild(bar);
          bar.dataset.awkMobilePortal = 'true';
        };

        const readScrollProgress = () => {
          const viewportHeight = window.visualViewport?.height
            || window.innerHeight
            || document.documentElement.clientHeight;
          const windowTop = Math.max(
            window.scrollY || 0,
            document.documentElement.scrollTop || 0,
            document.body.scrollTop || 0
          );
          const windowHeight = Math.max(
            document.documentElement.scrollHeight || 0,
            document.body.scrollHeight || 0
          );
          const windowMax = Math.max(windowHeight - viewportHeight, 0);
          const wrapperTop = scrollContainer?.scrollTop || 0;
          const wrapperMax = scrollContainer
            ? Math.max(scrollContainer.scrollHeight - scrollContainer.clientHeight, 0)
            : 0;
          const windowRatio = windowMax > 0 ? Math.min(Math.max(windowTop / windowMax, 0), 1) : 0;
          const wrapperRatio = wrapperMax > 0 ? Math.min(Math.max(wrapperTop / wrapperMax, 0), 1) : 0;

          return {
            ratio: Math.max(windowRatio, wrapperRatio),
            viewportHeight,
            source: wrapperRatio > windowRatio ? 'wrapper' : 'window'
          };
        };

        let frameRequested = false;
        const update = () => {
          frameRequested = false;
          const metrics = readScrollProgress();
          const previewBarHeight = document.getElementById('PBarNextFrameWrapper')?.getBoundingClientRect().height || 0;
          const footerTop = footerBoundary?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
          const footerLimit = Math.max(metrics.viewportHeight - previewBarHeight, 0);
          const shouldShow = metrics.ratio >= 0.5 && footerTop > footerLimit;
          const visibilityChanged = bar.classList.contains('is-visible') !== shouldShow;
          const bottomValue = `max(${previewBarHeight + 18}px, env(safe-area-inset-bottom))`;

          bar.dataset.awkScrollRatio = metrics.ratio.toFixed(3);
          bar.dataset.awkScrollSource = metrics.source;
          if (bar.dataset.awkStickyBottom !== bottomValue) {
            bar.dataset.awkStickyBottom = bottomValue;
            bar.style.setProperty('bottom', bottomValue, 'important');
          }
          bar.classList.toggle('is-visible', shouldShow);
          bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          if (visibilityChanged) {
            window.dispatchEvent(new CustomEvent('awk:sticky-buy-change', {
              detail: { visible: shouldShow }
            }));
          }

          if (shouldShow) {
            bar.removeAttribute('inert');
          } else {
            bar.setAttribute('inert', '');
          }
        };

        const requestUpdate = () => {
          if (frameRequested) return;
          frameRequested = true;
          window.requestAnimationFrame(update);
        };

        const handleViewportChange = () => {
          portalBarToViewport();
          requestUpdate();
        };

        portalBarToViewport();
        mobileViewport.addEventListener('change', handleViewportChange);
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate, { passive: true });
        window.addEventListener('orientationchange', requestUpdate, { passive: true });
        scrollContainer?.addEventListener('scroll', requestUpdate, { passive: true });
        window.visualViewport?.addEventListener('scroll', requestUpdate, { passive: true });
        window.visualViewport?.addEventListener('resize', requestUpdate, { passive: true });
        requestUpdate();
        window.setTimeout(requestUpdate, 1200);
      });
    };

    let stickyBuyInitialized = false;

    const runStickyBuy = () => {
      if (stickyBuyInitialized) return;
      stickyBuyInitialized = true;
      initializeStickyBuy(document);
    };

    const scheduleStickyBuy = () => {
      const runOnIntent = () => runStickyBuy();
      window.addEventListener('scroll', runOnIntent, { passive: true, once: true });
      window.addEventListener('touchstart', runOnIntent, { passive: true, once: true });
      window.addEventListener('pointerdown', runOnIntent, { passive: true, once: true });

      const schedule = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(runStickyBuy, { timeout: 1800 });
        } else {
          window.setTimeout(runStickyBuy, 450);
        }
      };

      if (document.readyState === 'complete') {
        schedule();
      } else {
        window.addEventListener('load', schedule, { once: true });
      }
    };

    const initialize = () => {
      initializeStandardProduct(document);
      scheduleStickyBuy();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeStandardProduct(event.target);
      initializeStickyBuy(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-col-bak-1952"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.__awkCollectionToolsBound) {
    window.__awkCollectionToolsBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-awk-filter-open]') : null;
      if (!trigger) return;

      const drawer = document.getElementById('filters-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    });

    document.addEventListener('change', (event) => {
      const select = event.target instanceof HTMLSelectElement ? event.target : null;
      if (!select || !select.matches('[data-awk-mobile-sort]')) return;

      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('sort_by', select.value);
      nextUrl.searchParams.delete('page');

      const section = select.closest('.shopify-section');
      const facetsForm = section?.querySelector('facets-form-component');

      if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(nextUrl.toString());
      } else {
        window.location.assign(nextUrl.toString());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-col-filter-bak-140826"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-before-catalog-summary-140826"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
